import type { EntityID } from "./three-d-schemas";

export {
  CAMERA_TYPE,
  threeDPanelConfigSchema,
  threeDPanelDataSchema,
  type Camera,
  type OrbitCamera,
  type ThirdPersonCamera,
  type PanelData,
  type PanelConfig,
  type Path,
  type PositionTransformation,
  type PositionBasePreset,
  type Position,
  type Sphere,
  type Box,
  type Mesh,
  type VectorFieldDisplayMode,
  type VectorField,
  type Grid,
  type Entity,
  type EntityID,
} from "./three-d-schemas";

export { deriveSourceFileIdFromAxes, type Axes } from "./axesFile";

export const DEFAULT_ENTITY_ID: EntityID = "entity0";
